// config
import { appConfig } from '../../../config/app-config';

export const jsonFormConfig = {
   debugParseSchema: false,
   debugParseLayout: false,
   debugParseData: false,

   dumpTreeContentAfterParseing: false
};



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/json-form/config/json-form.config.ts